<div class="modal-header">
  <h5 class="modal-title">{{ 'brapi-sync.study-filter.title' | translate }}</h5>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col">
      <form>
        <div class="form-group row pt-2">
          <label for="trialSelect" class="col-sm-3 col-form-label">{{ 'brapi-sync.study-filter.trial' | translate }}</label>
          <div class="col-sm-9">
            @if (!isTrialDisabled) {
              <app-dropdown-virtual-scroll bindLabel="trialName" [(selectedValue)]="trialSelected" [fetchMore]="brapiTrials"></app-dropdown-virtual-scroll>
            }
            @if (isTrialDisabled) {
              <span>{{trialSelected.trialName}}</span>
            }
          </div>
        </div>
        <div class="form-group row pt-2">
          <label for="locationSelect" class="col-sm-3 col-form-label">{{ 'brapi-sync.study-filter.location' | translate }}</label>
          <div class="col-sm-9">
            @if (!isLocationDisabled) {
              <app-dropdown-virtual-scroll bindLabel="locationName" [(selectedValue)]="locationSelected" [fetchMore]="brapiLocations"></app-dropdown-virtual-scroll>
            }
            @if (isLocationDisabled) {
              <span>{{locationSelected.locationName}}</span>
            }
          </div>
        </div>
        <div class="form-group row pt-2">
          <label for="studySelect" class="col-sm-3 col-form-label">{{ 'brapi-sync.study-filter.study-name' | translate }}</label>
          <div class="col-sm-9">
            @if (!isStudyDisabled) {
              <app-dropdown-virtual-scroll bindLabel="studyName" [(selectedValue)]="studySelected" [fetchMore]="brapiStudies"></app-dropdown-virtual-scroll>
            }
            @if (isStudyDisabled) {
              <span>{{studySelected.studyName}}</span>
            }
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="cancel()">{{ 'cancel' | translate }}</button>
  <button type="button" class="btn btn-primary" (click)="select()" [disabled]="!isValid()">
    @if (loading) {
      <span class="throbber throbber-btn"></span>
    }
    {{ 'brapi-sync.buttons.select' | translate }}
  </button>
</div>


